module.exports = __webpack_public_path__ + "static/media/carouselimg.39112b18.png";